import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Logger } from './logger.service';
import { environment } from '@env/environment';
import { LanguageUtil } from '@app/shared/utils/language.util';

const log = new Logger('I18nService');

@Injectable({
    providedIn: 'root'
})
export class I18nService {

    /************************************************************************************************************
     * @Localized variables
     ***********************************************************************************************************/

    LANGUAGES_NAME_MAP_LOCALIZED = LanguageUtil.LANGUAGES_NAME_MAP_LOCALIZED

    /************************************************************************************************************
     * @Undefined variables
     ***********************************************************************************************************/
    
    locales!: { [code: string]: string}
    private _selectedLocaleId$!: BehaviorSubject<string>;


    /************************************************************************************************************
     * @Getters
     ***********************************************************************************************************/

    /** */
    get selectedLocaleId$() { return this._selectedLocaleId$.asObservable(); }

    /** */
    get selectedLocaleId(): string { return this._selectedLocaleId$.getValue(); }

    /** */
    get selectedLocale(): string { return this.locales[this.selectedLocaleId]; }

    /************************************************************************************************************
     * @Setters
     ***********************************************************************************************************/

    /** */
    set selectedLocaleId(selectedLocaleId: string) {
        log.info(`Selecting '${selectedLocaleId}'`);
        if (this._isSupported(selectedLocaleId)) {
            this._selectedLocaleId$.next(selectedLocaleId);
        } else {
            log.error(`'${selectedLocaleId}' does not correspond to a supported language`);
        }
    }

    /************************************************************************************************************
     * @Constructor
     ***********************************************************************************************************/

    constructor(@Inject(LOCALE_ID) protected localeId: string) {
        this.locales = Object.keys(environment.supportedLanguages).reduce((locales, code) => ({ ...locales, [code]: this.LANGUAGES_NAME_MAP_LOCALIZED.get(code) }), {});
        log.info(`Initialized for supported languages: '${Object.keys(this.locales).join('\', \'')}'`);

        log.info(`Using '${localeId.toLowerCase()}' from configured app locale`);
        this._selectedLocaleId$ = new BehaviorSubject<string>(localeId.toLowerCase());
    }

    /************************************************************************************************************
     * @Private methods
     ***********************************************************************************************************/

    /** */
    private _isSupported(code: string): boolean {
        return this.locales.hasOwnProperty(code);
    }
}
